import React from "react"

import '../styles/pages/BlogPage.css'

import Menu from "../components/Menu";
import Footer from "../components/Footer";
import BlogComponent from "../components/BlogComponent";


const BlogPage = () => {

    return (
        <>
            <header className='blog-header'>
                <Menu/>
            </header>
            <BlogComponent/>
            <Footer/>
        </>
    );
}

export default BlogPage;